import type { Template } from "@/types";

export const LA_07_H7_V0: Template[] = [
{
    id: "la-07-h7v0-01",
    name: "LA 01 - H7V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h7_v0_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 74, y: 75, width: 241, height: 160, rotation: 0, imageRotation: 0 },
            { id: "2", x: 74, y: 242, width: 241, height: 160, rotation: 0, imageRotation: 0 },
            { id: "3", x: 322, y: 75, width: 241, height: 160, rotation: 0, imageRotation: 0 },
            { id: "4", x: 322, y: 242, width: 241, height: 160, rotation: 0, imageRotation: 0 },
            { id: "5", x: 747, y: 46, width: 204, height: 125, rotation: 0, imageRotation: 0 },
            { id: "6", x: 747, y: 177, width: 416, height: 255, rotation: 0, imageRotation: 0 },
            { id: "7", x: 959, y: 46, width: 204, height: 125, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h7v0-02",
    name: "LA 02 - H7V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h7_v0_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 37, y: 51, width: 565, height: 375, rotation: 0, imageRotation: 0 },
            { id: "2", x: 755, y: 51, width: 197, height: 120, rotation: 0, imageRotation: 0 },
            { id: "3", x: 755, y: 178, width: 197, height: 120, rotation: 0, imageRotation: 0 },
            { id: "4", x: 755, y: 307, width: 197, height: 119, rotation: 0, imageRotation: 0 },
            { id: "5", x: 959, y: 51, width: 197, height: 120, rotation: 0, imageRotation: 0 },
            { id: "6", x: 959, y: 178, width: 197, height: 120, rotation: 0, imageRotation: 0 },
            { id: "7", x: 959, y: 307, width: 197, height: 119, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h7v0-03",
    name: "LA 03 - H7V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h7_v0_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 88, y: 48, width: 459, height: 270, rotation: 0, imageRotation: 0 },
            { id: "2", x: 88, y: 325, width: 148, height: 106, rotation: 0, imageRotation: 0 },
            { id: "3", x: 243, y: 325, width: 148, height: 106, rotation: 0, imageRotation: 0 },
            { id: "4", x: 399, y: 325, width: 148, height: 106, rotation: 0, imageRotation: 0 },
            { id: "5", x: 729, y: 48, width: 458, height: 237, rotation: 0, imageRotation: 0 },
            { id: "6", x: 729, y: 291, width: 225, height: 139, rotation: 0, imageRotation: 0 },
            { id: "7", x: 962, y: 291, width: 225, height: 139, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h7v0-04",
    name: "LA 04 - H7V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h7_v0_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 53, y: 63, width: 532, height: 352, rotation: 0, imageRotation: 0 },
            { id: "2", x: 690, y: 63, width: 173, height: 113, rotation: 0, imageRotation: 0 },
            { id: "3", x: 690, y: 182, width: 173, height: 113, rotation: 0, imageRotation: 0 },
            { id: "4", x: 690, y: 302, width: 173, height: 113, rotation: 0, imageRotation: 0 },
            { id: "5", x: 871, y: 63, width: 172, height: 113, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1051, y: 63, width: 172, height: 113, rotation: 0, imageRotation: 0 },
            { id: "7", x: 871, y: 182, width: 352, height: 232, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h7v0-05",
    name: "LA 05 - H7V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h7_v0_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 230, y: 48, width: 267, height: 186, rotation: 0, imageRotation: 0 },
            { id: "2", x: 504, y: 48, width: 267, height: 186, rotation: 0, imageRotation: 0 },
            { id: "3", x: 778, y: 48, width: 266, height: 186, rotation: 0, imageRotation: 0 },
            { id: "4", x: 94, y: 241, width: 266, height: 186, rotation: 0, imageRotation: 0 },
            { id: "5", x: 368, y: 241, width: 266, height: 186, rotation: 0, imageRotation: 0 },
            { id: "6", x: 641, y: 241, width: 266, height: 186, rotation: 0, imageRotation: 0 },
            { id: "7", x: 914, y: 241, width: 265, height: 186, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h7v0-06",
    name: "LA 06 - H7V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h7_v0_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 102, y: 34, width: 262, height: 171, rotation: 0, imageRotation: 0 },
            { id: "2", x: 371, y: 34, width: 262, height: 171, rotation: 0, imageRotation: 0 },
            { id: "3", x: 641, y: 34, width: 262, height: 171, rotation: 0, imageRotation: 0 },
            { id: "4", x: 910, y: 34, width: 261, height: 171, rotation: 0, imageRotation: 0 },
            { id: "5", x: 102, y: 213, width: 351, height: 229, rotation: 0, imageRotation: 0 },
            { id: "6", x: 461, y: 213, width: 351, height: 229, rotation: 0, imageRotation: 0 },
            { id: "7", x: 820, y: 213, width: 351, height: 229, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h7v0-07",
    name: "LA 07 - H7V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h7_v0_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 47, y: 39, width: 191, height: 127, rotation: 0, imageRotation: 0 },
            { id: "2", x: 47, y: 174, width: 191, height: 127, rotation: 0, imageRotation: 0 },
            { id: "3", x: 47, y: 309, width: 191, height: 126, rotation: 0, imageRotation: 0 },
            { id: "4", x: 246, y: 309, width: 190, height: 126, rotation: 0, imageRotation: 0 },
            { id: "5", x: 444, y: 309, width: 190, height: 126, rotation: 0, imageRotation: 0 },
            { id: "6", x: 246, y: 39, width: 388, height: 262, rotation: 0, imageRotation: 0 },
            { id: "7", x: 642, y: 39, width: 586, height: 396, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h7v0-08",
    name: "LA 08 - H7V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h7_v0_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 46, y: 39, width: 586, height: 396, rotation: 0, imageRotation: 0 },
            { id: "2", x: 640, y: 39, width: 191, height: 127, rotation: 0, imageRotation: 0 },
            { id: "3", x: 640, y: 174, width: 191, height: 127, rotation: 0, imageRotation: 0 },
            { id: "4", x: 640, y: 309, width: 191, height: 126, rotation: 0, imageRotation: 0 },
            { id: "5", x: 839, y: 309, width: 190, height: 126, rotation: 0, imageRotation: 0 },
            { id: "6", x: 839, y: 39, width: 388, height: 262, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1037, y: 309, width: 190, height: 126, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h7v0-09",
    name: "LA 09 - H7V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h7_v0_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 67, y: 68, width: 334, height: 225, rotation: 0, imageRotation: 0 },
            { id: "2", x: 408, y: 68, width: 163, height: 109, rotation: 0, imageRotation: 0 },
            { id: "3", x: 408, y: 184, width: 163, height: 109, rotation: 0, imageRotation: 0 },
            { id: "4", x: 67, y: 300, width: 163, height: 108, rotation: 0, imageRotation: 0 },
            { id: "5", x: 237, y: 300, width: 163, height: 108, rotation: 0, imageRotation: 0 },
            { id: "6", x: 408, y: 300, width: 163, height: 108, rotation: 0, imageRotation: 0 },
            { id: "7", x: 637, y: 0, width: 637, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h7v0-10",
    name: "LA 10 - H7V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h7_v0_10.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 0, width: 637, height: 476, rotation: 0, imageRotation: 0 },
            { id: "2", x: 704, y: 68, width: 334, height: 225, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1045, y: 68, width: 163, height: 109, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1045, y: 184, width: 163, height: 109, rotation: 0, imageRotation: 0 },
            { id: "5", x: 704, y: 300, width: 163, height: 108, rotation: 0, imageRotation: 0 },
            { id: "6", x: 874, y: 300, width: 163, height: 108, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1045, y: 300, width: 163, height: 108, rotation: 0, imageRotation: 0 }
    ],
}
];